import { render, staticRenderFns } from "./block-assessment-information.vue?vue&type=template&id=35f2edb5&scoped=true"
import script from "./block-assessment-information.vue?vue&type=script&lang=js"
export * from "./block-assessment-information.vue?vue&type=script&lang=js"
import style0 from "./block-assessment-information.vue?vue&type=style&index=0&id=35f2edb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2edb5",
  null
  
)

export default component.exports